// LandingPage.js
import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Modal from "../Modal";
import AnnaPNG from "../../assets/Anna_1.png";
import anna2 from "../../assets/Anna_2.png";
import { ChatbotContext } from "../../context/ChatbotContext";
import { toast } from "react-toastify";
import Chatbot from "../chatbot/Chatbot";
import "../../styles/style.css";
import "../../styles/landing-page.css";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import TermsConditionsModal from "./TermsConditionsModal.js";
import api from "../../styles/../utils/api"; // Import the Axios instance
import { useModal } from "react-modal-state"; // Correct usage of useModal

import { UserContext } from "../../context/UserContext"; // Import UserContext
import { savePostLoginRedirect, takePostLoginRedirect } from "../../utils/authRedirect";
import Icon from "../common/icons";
import AssessmentIcon from "../common/AssessmentIcon";
import LandingScrollCue from "./LandingScrollCue";
import StudentTour, { startStudentTour } from "./StudentTour";
import { TOUR_PARAM, takeTourRequest } from "./replayStudentTour";
import { GetAppLandingButton } from "../../pwa/GetAppNudges";
import { clearWaitingOnSignOut } from "../chatbot/testShell/signOutAnswers";
import { isSharedComputer } from "../../utils/sharedComputer";
import { TEST_PARAM, requestTest, testFromSearch } from "../chatbot/openTestRequest";
import { turnOffPushOnSignOut } from "../../pwa/pushSignOut";
import { clearStudentTraces, hasSignedInHere } from "../../utils/studentTraces";

window.$ = $;
window.jQuery = $;

// The four assessments, named as on the student Results page
const LANDING_ASSESSMENTS = [
  {
    type: "riasec",
    name: "Career interests",
    code: "RIASEC",
    minutes: "About 15 min",
    questions: 42,
    description: "Discover your career interests and personality type, based on Holland's theory.",
  },
  {
    type: "sdq",
    name: "Strengths and difficulties",
    code: "SDQ",
    minutes: "About 10 min",
    questions: 25,
    description: "Look at strengths and difficulties in behavior and emotional well-being.",
  },
  {
    type: "dass42",
    name: "Mood and stress",
    code: "DASS-42",
    minutes: "About 12 min",
    questions: 42,
    description: "Check your levels of depression, anxiety and stress for insight into your mental wellness.",
  },
  {
    type: "ryff",
    name: "Well-being",
    code: "Ryff scale",
    minutes: "About 15 min",
    questions: 42,
    description: "Measure psychological well-being across six key areas of personal growth.",
  },
];

const LandingPage = () => {
  const { setShowbot, showBot, isAgreeTermsConditions } =
    useContext(ChatbotContext);
  const [refresh, setRefresh] = useState(false);
  const [auth, setAuth] = useState(false); // Add state for authentication
  const { fetchUserData } = useContext(UserContext);
  const { open: openLoginModal, close: closeLoginModal } = useModal("login");
  const { isAuthenticated, setIsAuthenticated, user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  // Add effect to check authentication status
  useEffect(() => {
    const checkAuth = async () => {
      try {
        await fetchUserData();
      } catch (error) {
        console.error("Error checking authentication:", error);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkAuth();
  }, []); // Remove fetchUserData dependency to prevent infinite loop

  // ?login=1 opens the sign-in dialog and ?redirect= is where to go after it. Read once
  // on arrival: openLoginModal changes every render, and re-running this would reopen
  // the dialog while it closes after a sign-in.
  const navigate = useNavigate();
  const loginParamsRead = useRef(false);
  useEffect(() => {
    if (isLoading || loginParamsRead.current) return;
    loginParamsRead.current = true;

    const params = new URLSearchParams(window.location.search);
    const wantsLogin = params.get("login") === "1";
    const redirectPath = params.get("redirect");

    if (redirectPath && redirectPath.startsWith("/")) {
      savePostLoginRedirect(redirectPath);
    }

    if (wantsLogin && !isAuthenticated) {
      openLoginModal();
    } else if (redirectPath && redirectPath.startsWith("/") && isAuthenticated) {
      takePostLoginRedirect();
      navigate(redirectPath, { replace: true });
    }
  }, [isLoading, isAuthenticated, openLoginModal, navigate]);

  // "Quick tour" in the account menu on another page comes here as /?tour=1 (N7)
  useEffect(() => {
    if (isLoading) return undefined;
    if (new URLSearchParams(window.location.search).get(TOUR_PARAM) !== "1") return undefined;
    // After the chat has opened by itself, like the first-visit tour
    const id = setTimeout(() => {
      if (takeTourRequest()) startStudentTour();
    }, 900);
    return () => clearTimeout(id);
  }, [isLoading]);

  // /?test=<type> (N4): Resume on Results and the chat's cards open that test in the chat, at
  // the next question when it was started. Signed out, it asks to sign in first and comes back.
  const testParamDone = useRef(false);
  useEffect(() => {
    if (isLoading || testParamDone.current) return;
    const type = testFromSearch(window.location.search);
    if (!type) return;
    if (!isAuthenticated) {
      savePostLoginRedirect(`/?${TEST_PARAM}=${type}`);
      openLoginModal();
      return;
    }
    testParamDone.current = true;
    requestTest(type);
    setShowbot(true);
    // Drop it from the address so a reload doesn't open the test again
    const params = new URLSearchParams(window.location.search);
    params.delete(TEST_PARAM);
    const rest = params.toString();
    navigate(`/${rest ? `?${rest}` : ""}${window.location.hash || ""}`, { replace: true });
  }, [isLoading, isAuthenticated]);

  // Handle Get Started button click
  const handleGetStarted = () => {
    console.log("handleGetStarted called");
    console.log("showBot state:", showBot);

    // Chatbot is only available to logged-in users
    if (!isAuthenticated) {
      openLoginModal();
      return;
    }

    if (!showBot) {
      // If chatbot is closed, open it
      console.log("Chatbot is closed, opening chatbot...");
      setShowbot(true);
    } else {
      // If chatbot is already open, open terms and conditions modal
      console.log("Chatbot is open, trying to open terms modal...");
      const modalElement = document.getElementById("modal-terms-conditions");
      console.log("Modal element found:", modalElement);

      if (modalElement) {
        try {
          const modal = new bootstrap.Modal(modalElement);
          console.log("Bootstrap modal instance created:", modal);
          modal.show();
          console.log("Modal.show() called");
        } catch (error) {
          console.error("Error opening modal:", error);
        }
      } else {
        console.error(
          "Modal element not found with ID: modal-terms-conditions",
        );
      }
    }
  };

  const [showTerms, setShowTerms] = useState(false);

  const [formData, setFormData] = useState({
    id_no: "",
    full_name: "",
    email: "",
    password: "",
    confirm_password: "",
    school_id: "",
    mobile_no: "",
    sex: "",
    age: "", // Add age
    strand: "",
    grade_level: "",
  });

  const [feedbackData, setFeedbackData] = useState({
    feedbackEmail: "",
    feedback: "",
  });

  const { setUser } = useContext(ChatbotContext);
  const navlinks = [
    { text: "Home", link: "/#home" },
    { text: "Our Assessments", link: "/#our-assessments" },
    { text: "ANNA Demo", link: "/#anna-demonstration" },
    { text: "Feedback", link: "/#feedback" },
  ];

  useEffect(() => {
    // The sign-in dialog has closed and the app is signed in (LoginModal.handleExited);
    // the chat is opening. No page reload: the Chatbot mounts now and loads the student.
    const handleLoginSuccess = () => {
      setAuth(true); // Shows the tour button
      setShowbot(true);
      // Auto-start of the quick tour after first sign-in is off for now.
      // Re-enable: if the student has no conversations yet, call startStudentTour
      // after the chat opens (or after chatbotRefresh if a section check is first).
    };

    window.addEventListener("loginSuccess", handleLoginSuccess);
    return () => window.removeEventListener("loginSuccess", handleLoginSuccess);
  }, []);

  const refreshAccessToken = async () => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      const response = await api.post("/api/token/refresh/", {
        refresh: refreshToken,
      });

      if (response.status === 200) {
        localStorage.setItem("authToken", response.data.access);
        return response.data.access;
      } else {
        // Handle refresh token expiration
        handleLogout();
        return null;
      }
    } catch (err) {
      console.error("Error refreshing access token:", err);
      handleLogout();
      return null;
    }
  };
  const [inputs, setInputs] = useState({ feedbackEmail: "", feedback: "" });
  const { feedback } = feedbackData;

  const handleInputChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleFeedbackChange = (e) => {
    const { name, value } = e.target;

    // Update the state without validating immediately
    setFeedbackData({ ...feedbackData, [name]: value });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (name === "feedbackEmail") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Standard email regex
      if (value && !emailPattern.test(value)) {
        toast.error("Please enter a valid email address");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);

    if (
      !formData.id_no ||
      !formData.full_name ||
      !formData.email ||
      !formData.password ||
      !formData.confirm_password
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    const data = {
      id_no: formData.id_no,
      full_name: formData.full_name,
      email: formData.email, // Fixed here
      password: formData.password,
      confirm_password: formData.confirm_password,
      school_id: formData.school_id,
      mobile_no: formData.mobile_no,
      sex: formData.sex,
      strand: formData.strand,
      grade_level: formData.grade_level,
    };

    console.log("Data to be sent:", data);

    try {
      const response = await api.post("/register/", data, {
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCookie("csrftoken"),
        },
      });
      if (response.status === 201) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.error(err.message);
      toast.error("Registration failed. Please try again.");
    }
  };

  const handleLogout = () => {
    // Read while still signed in: the "Shared computer" choice lasts for this sign-in only
    const shared = isSharedComputer();
    // Notifications stop on this phone (shared phones); needs the token, so it goes first
    turnOffPushOnSignOut();
    // Remove tokens from localStorage
    localStorage.removeItem("authToken"); // Main auth token
    localStorage.removeItem("token"); // Chatbot access token
    localStorage.removeItem("refreshToken"); // Refresh token
    localStorage.removeItem("isAuthenticated");
    // Test answers still waiting for the internet: kept on a personal phone (this also runs for
    // automatic sign-outs), cleared on a shared computer; Log out asks first and clears them (F21)
    clearWaitingOnSignOut({ shared });
    // ...and everything else the chat kept here (same as clearSession in utils/api.js)
    clearStudentTraces();

    // Reset authentication and chatbot states
    setAuth(false); // Set authentication state to logged out
    setShowbot(false); // Hide chatbot after logout

    // Safely check if setUser is available before calling it
    if (typeof setUser === "function") {
      setUser(null); // Clear user data in chatbot context, if applicable
    }

    toast.success("Logged out successfully!");
    window.location.reload(); // Reload the window to apply changes
  };

  const checkAuthStatus = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      // No token -> not logged in. Sign-in opens by itself only for someone who has signed
      // in on this device before; a first-timer reads the page first (N7).
      setIsAuthenticated(false);
      if (hasSignedInHere()) openLoginModal();
      setShowbot(false);
      return;
    }

    try {
      const response = await api.get("/api/check_login_status/", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200 && response.data.is_logged_in) {
        setIsAuthenticated(true);
        setAuth(true); // Set auth state to show tour button
        closeLoginModal();
        setShowbot(true);
        fetchUserData();
      } else {
        setIsAuthenticated(false);
        openLoginModal();
        setShowbot(false);
      }
    } catch (err) {
      console.error("Error checking auth status:", err);
      setIsAuthenticated(false);
      openLoginModal();
      setShowbot(false);
    }
  };

  useEffect(() => {
    // On component load, check if user is authenticated
    checkAuthStatus();
  }, []);

  // Footer address: the signed-in visitor's own school; signed-out visitors get none
  const [school, setSchool] = useState(null);
  useEffect(() => {
    if (!isAuthenticated) {
      setSchool(null);
      return undefined;
    }
    let cancelled = false;
    api
      .get("/api/school-info/")
      .then(({ data }) => {
        if (!cancelled && data?.school_des) {
          setSchool({ name: data.school_des, address: data.school_add || "" });
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  const getCookie = (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === `${name}=`) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };
  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();
    const { feedbackEmail, feedback } = feedbackData;

    if (!feedback) {
      toast.error("Feedback can't be empty");
      return;
    }

    // Retrieve or create a session ID for guests
    let sessionId = localStorage.getItem("session_id");
    if (!sessionId) {
      sessionId = crypto.randomUUID(); // Generate a persistent session ID
      localStorage.setItem("session_id", sessionId);
    }

    try {
      // Check if the user has already submitted feedback today
      const checkResponse = await api.get("/api/check-feedback/", {
        params: {
          category: "landing_page",
          email: feedbackEmail,
          session_id: sessionId,
        },
      });

      if (checkResponse.data.exists) {
        toast.info("You have already submitted feedback today.");
        return;
      }

      const response = await api.post("/api/submit-feedback/", {
        category: "landing_page",
        session_id: sessionId, // Send session_id
        rating: null, // No rating for landing page
        feedback,
      });

      if (response.status === 201) {
        toast.success("Feedback submitted successfully!");
        setFeedbackData({ feedbackEmail: "", feedback: "" });
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error("Failed to submit feedback.");
    }
  };

  return (
    <>
      <StudentTour />
      <Header navlinks={navlinks} auth={auth} handleLogout={handleLogout} />
      <section id="home" className="lp-section lp-hero">
        <div className="container lp-hero-inner">
          <div className="lp-hero-text">
            {isAuthenticated && user?.full_name && (
              <p className="lp-eyebrow">
                {`Welcome back, ${user.full_name.trim().split(/\s+/)[0]}`}
              </p>
            )}
            <h1 className="lp-hero-title">
              Meet <span className="lp-highlight">Anna</span>, your guidance chatbot
            </h1>
            <p className="lp-hero-lede">
              A guidance chatbot for students and staff. Short chats about career
              interests, strengths and difficulties, mood and stress, and well-being help
              you understand yourself and know when to reach out to your guidance office.
            </p>
            <div className="lp-hero-actions">
              <button type="button" className="lp-btn lp-btn--primary" onClick={handleGetStarted}>
                {isAuthenticated ? "Chat with Anna" : "Get started"}
                <Icon name="arrow-right" size={18} />
              </button>
              {auth && (
                <button type="button" className="lp-btn lp-btn--ghost" onClick={startStudentTour}>
                  <Icon name="compass" size={18} />
                  Take a quick tour
                </button>
              )}
              {!isAuthenticated && (
                <a className="lp-btn lp-btn--ghost" href="#anna-demonstration">
                  <Icon name="play-circle" size={18} />
                  Watch the demo
                </a>
              )}
            </div>
            {/* Phones only: opens the "Get the ANNA app" card */}
            <GetAppLandingButton />
            <ul className="lp-hero-facts">
              <li><Icon name="layers" size={16} />4 assessments</li>
              <li><Icon name="clock" size={16} />10–15 minutes each</li>
              <li><Icon name="chat" size={16} />Done in a chat with Anna</li>
            </ul>
          </div>
          <div className="lp-hero-art">
            <img src={AnnaPNG} alt="Anna, the guidance chatbot" className="lp-hero-img" />
          </div>
        </div>
        <LandingScrollCue targetId="our-assessments" />
      </section>

      <section id="our-assessments" className="lp-section">
        <div className="container">
          <div className="lp-section-head">
            <p className="lp-eyebrow">Assessments</p>
            <h2 className="lp-h2">Four short assessments, one clearer picture</h2>
            <p className="lp-section-lede">
              Each one is a conversation with Anna. Take them at your own pace.
            </p>
          </div>
          <div className="lp-cards">
            {LANDING_ASSESSMENTS.map((test) => (
              <article key={test.type} className="lp-card">
                <span className="lp-card-icon">
                  <AssessmentIcon type={test.type} size={24} />
                </span>
                <h3 className="lp-card-title">{test.name}</h3>
                <p className="lp-card-code">{test.code}</p>
                <p className="lp-card-text">{test.description}</p>
                <ul className="lp-card-meta">
                  <li><Icon name="clock" size={15} />{test.minutes}</li>
                  <li><Icon name="list" size={15} />{test.questions} questions</li>
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="anna-demonstration" className="lp-section lp-section--tint">
        <div className="container">
          <div className="lp-section-head">
            <p className="lp-eyebrow">See it in action</p>
            <h2 className="lp-h2">See how Anna works</h2>
            <p className="lp-section-lede">
              Take an assessment in a chat, read your results in plain language, and book a
              session with your guidance office.
            </p>
          </div>
          <div className="lp-video">
            <iframe
              id="anna-demo"
              loading="lazy"
              src="https://www.youtube-nocookie.com/embed/Pca_JdRn3lE?rel=0"
              title="See how Anna works"
              frameBorder="0"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
          </div>
        </div>
      </section>

      <section id="feedback" className="lp-section">
        <div className="container">
          <div className="lp-feedback">
            <div>
              <p className="lp-eyebrow">Feedback</p>
              <h2 className="lp-h2">Help us make Anna better</h2>
              <p className="lp-section-lede">
                Tell us what worked, what didn't, or what you'd like Anna to do next.
              </p>
            </div>
            <form className="lp-feedback-form" noValidate onSubmit={handleFeedbackSubmit}>
              <label htmlFor="feedback-message" className="lp-label">
                Your feedback
              </label>
              <textarea
                id="feedback-message"
                name="feedback"
                className="lp-textarea"
                rows="6"
                required
                value={feedbackData.feedback}
                placeholder="Tell us how we can improve..."
                onChange={handleFeedbackChange}
              ></textarea>
              <button className="lp-btn lp-btn--primary" type="submit">
                Send feedback
                <Icon name="send" size={16} />
              </button>
            </form>
          </div>
        </div>
      </section>
      {!isLoading && isAuthenticated && (
        <Chatbot key={refresh} minimizeOnClose={true} />
      )}

      <footer className="lp-footer">
        <div className="container">
          <div className={`lp-footer-grid${school ? "" : " lp-footer-grid--no-school"}`}>
            <div className="lp-footer-brand">
              <a href="/" className="lp-footer-logo">
                <img src={anna2} alt="" />
                <span>Anna</span>
              </a>
              <p>
                Anna is an AI-powered guidance system that supports the holistic
                development of students and staff through assessments in career
                exploration, mental health screening, well-being and behavior.
              </p>
            </div>
            <nav className="lp-footer-col" aria-labelledby="lp-footer-explore">
              <h2 className="lp-footer-title" id="lp-footer-explore">Explore</h2>
              <ul>
                <li><a href="/#home">Home</a></li>
                <li><a href="/#our-assessments">Our Assessments</a></li>
                <li><a href="/#anna-demonstration">ANNA Demo</a></li>
                <li><a href="/#feedback">Feedback</a></li>
                <li>
                  <button type="button" onClick={() => setShowTerms(true)}>
                    Terms & Conditions
                  </button>
                </li>
              </ul>
            </nav>
            {school && (
              <div className="lp-footer-col">
                <h2 className="lp-footer-title">Your school</h2>
                <address>
                  {school.name}
                  {school.address && (
                    <>
                      <br />
                      {school.address}
                    </>
                  )}
                </address>
              </div>
            )}
            <div className="lp-footer-col">
              <h2 className="lp-footer-title">Contact us</h2>
              <a className="lp-footer-mail" href="mailto:aniagtechsolutions@gmail.com">
                aniagtechsolutions@gmail.com
              </a>
            </div>
          </div>
          <div className="lp-footer-bottom">© 2026 ANNA</div>
        </div>

        {/* Render the Terms & Conditions Modal */}
        <TermsConditionsModal
          open={showTerms}
          close={() => setShowTerms(false)}
        />
      </footer>
    </>
  );
};

export default LandingPage;
